// Moneda del plan del media plan (UD-2 de /ux, 2026-10-15). La decide el backend al armar la
// propuesta y viaja en `proposal.plan_currency` = `{code, source, options, suggested}`:
//   - `code` vacío  → no hubo con qué decidirla: la pantalla pregunta arriba y no se aprueba nada.
//   - `source`      → de dónde salió (USER, SHEET, SPEND, ACCOUNTS, AI), para decirlo en pantalla.
// Una propuesta anterior al cambio trae `{}` (o nada): sin bloque y sin bloqueo, como antes.
// Módulo puro para poder testearlo sin montar la vista.

export const PLAN_CURRENCY_PIN_KEY = 'plan_currency';

export const PLAN_CURRENCY_SOURCES = ['USER', 'SHEET', 'SPEND', 'ACCOUNTS', 'AI'];

// La duda de moneda se responde en el bloque de moneda, no en la lista de dudas.
export function isPlanCurrencyQuestion(item) {
    return ((item && item.question) || {}).profile_pin_key === PLAN_CURRENCY_PIN_KEY;
}

export function planCurrencyState(proposal) {
    const planCurrency = (proposal && proposal.plan_currency) || {};
    const hasPlanCurrency = Object.keys(planCurrency).length > 0;
    return {planCurrency, hasPlanCurrency, needsCurrency: hasPlanCurrency && !planCurrency.code};
}
